import template from './dashboard.html'
import css from './dashboard.css'
import { DashboardController } from './dashboard.controller.js'

export const DashboardComponent = {
  template: template,
  controller: DashboardController,
  controllerAs: 'DashboardController',
  require:{
  	parentSimulator: '^^simulatorComponent'
  },
  bindings: {
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/dashboard/dashboard.component.js